var _defs, _use, _use2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "a",
    viewBox: "0 0 359 231"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#e2e8f0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 15,
    d: "M295.5 223.5a56 56 0 000-112l-2.5.1a83.9 83.9 0 00-153-64.2 56 56 0 00-84.6 48.1 56.6 56.6 0 00.8 9 60 60 0 0011.2 119"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "b",
    overflow: "visible",
    viewBox: "0 0 136 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#86c3db",
    d: "M12 0a12 12 0 1012 12A12 12 0 0012 0Z",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animateTransform", {
    id: "x1",
    additive: "sum",
    attributeName: "transform",
    begin: "0s; x1.end+.42s",
    dur: ".58s",
    keyTimes: "0; .71; 1",
    type: "translate",
    values: "0 -46; 0 86; -18 74"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "y1",
    attributeName: "opacity",
    begin: "0s; y1.end+.42s",
    dur: ".58s",
    keyTimes: "0; .14; .71; 1",
    values: "0; 1; 1; 0"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#86c3db",
    d: "M68 0a12 12 0 1012 12A12 12 0 0068 0Z",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animateTransform", {
    id: "x2",
    additive: "sum",
    attributeName: "transform",
    begin: ".67s; x2.end+.42s",
    dur: ".58s",
    keyTimes: "0; .71; 1",
    type: "translate",
    values: "0 -46; 0 86; 0 74"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "y2",
    attributeName: "opacity",
    begin: ".67s; y2.end+.42s",
    dur: ".58s",
    keyTimes: "0; .14; .71; 1",
    values: "0; 1; 1; 0"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#86c3db",
    d: "M124 0a12 12 0 1012 12 12 12 0 00-12-12Z",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animateTransform", {
    id: "x3",
    additive: "sum",
    attributeName: "transform",
    begin: ".33s; x3.end+.42s",
    dur: ".58s",
    keyTimes: "0; .71; 1",
    type: "translate",
    values: "0 -46; 0 86; 18 74"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "y3",
    attributeName: "opacity",
    begin: ".33s; y3.end+.42s",
    dur: ".58s",
    keyTimes: "0; .14; .71; 1",
    values: "0; 1; 1; 0"
  }))))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: 359,
    height: 231,
    transform: "translate(76.5 140.5)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    width: 136,
    height: 24,
    transform: "translate(188 350)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHail);
export default __webpack_public_path__ + "static/media/hail.1e6a60591d181485d0de32062fbf7adc.svg";
export { ForwardRef as ReactComponent };